module Dashboard {
    "use strict";

    export function widgetHeaderDirective(): ng.IDirective {
        return {
            restrict: "EA",
            scope: true,
            bindToController: {
                config: "=",
                settingsTemplateUrl: "@",
                callback: "&"
            },
            templateUrl: "widgetHeaderTemplate.htm",
            controller: "widgetHeaderController as ctrl"
        }
    }
    module.directive("frendsWidgetHeader", [widgetHeaderDirective]);

    export class WidgetHeaderController {
        public config: IWidgetConfig;
        public settingsTemplateUrl: string;
        public callback: Function;

        static $inject = ["$uibModal", "DashboardConfigService"];
        constructor(private $uibModal, private dashboardConfigService: DashboardConfigService) { }
        
        public openSettingsModal() {
            var modalInstance = this.$uibModal.open({
                animation: true,
                templateUrl: "widgetSettingsModalLayout.htm",
                controller: "widgetSettingsModalController as ctrl",
                resolve: {
                    config: () => angular.copy(this.config),
                    settingsTemplateUrl: () => this.settingsTemplateUrl
                }
            });

            modalInstance.result.then((updatedConfig) => {
                this.dashboardConfigService.updateWidgetConfig(updatedConfig);
                this.callback({updatedConfig: updatedConfig});
            });
        };
        
        public saveConfig() {
            this.dashboardConfigService.updateWidgetConfig(this.config);
        }
    }
    module.controller("widgetHeaderController", WidgetHeaderController);

    export class WidgetSettingsModalController {
        static $inject = ["$uibModalInstance", "config", "settingsTemplateUrl"];
        constructor(private $uibModalInstance, public config: IExecutionCountWidget, public settingsTemplateUrl: string) { }

        public save() {
            this.$uibModalInstance.close(this.config);
        }
        public cancel() {
            this.$uibModalInstance.dismiss();
        }        
    }
    module.controller("widgetSettingsModalController", WidgetSettingsModalController);
}